import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import './index.css';
import Themes from 'themes';
const ThemeContext = React.createContext(Themes.themes1);

const FooterMenu = () => {
  const { t } = useTranslation();
  const entryType = [
    {key:0, title: t('FooterMenu.title1'), url: 'https://web-asia-dev.prdws.com/' },
    {key:1, title: t('FooterMenu.title2'), url: 'https://web-asia-dev.prdws.com/' },
    {key:2, title: t('FooterMenu.title3'), url: 'https://web-asia-dev.prdws.com/' },
    {key:3, title: t('FooterMenu.title4'), url: 'https://web-asia-dev.prdws.com/' },
    {key:4, title: t('FooterMenu.title5'), url: 'https://web-asia-dev.prdws.com/' },
  ]

  const Themes = useContext(ThemeContext);
  return(
    <ul>{entryType.map(({key, title, url}) => <li key={key} style={{ color: Themes.color }}><a href={url}>{title}</a></li>)}</ul>
  )
}

export default FooterMenu
